import { render } from "./ShareIt.vue?vue&type=template&id=3d665865"
import script from "./ShareIt.vue?vue&type=script&lang=js"
export * from "./ShareIt.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__